export default __webpack_public_path__ + "static/media/Newday_QUESTIONNAIRE.8473b081.pdf";